import React from 'react'
import {
  Award,
  Users,
  CheckCircle,
  Stethoscope,
  Bot,
  Heart,
  Star,
  TrendingUp
} from 'lucide-react'

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "David Benaim",
      role: "Expert Capillaire",
      specialization: "Greffes SAPHORÏ®, CHOÏ, SAPHIR",
      experience: "15+ ans",
      image: "/mobile-optimized/team/david.webp",
      icon: <Award size={24} />,
      description: "Expert capillaire spécialisé dans les techniques de greffe les plus avancées.",
      certifications: ["SAPHORÏ®", "CHOÏ", "SAPHIR"]
    },
    {
      id: 2,
      name: "Dr. Lionel Choukroun",
      role: "Chirurgien Esthétique",
      specialization: "Chirurgie Esthétique & Reconstructrice",
      experience: "10+ ans",
      image: "/mobile-optimized/team/lionel.webp",
      icon: <Stethoscope size={24} />,
      description: "Chirurgien esthétique spécialisé en interventions chirurgicales esthétiques et reconstructrices.",
      certifications: ["Chirurgie Esthétique", "Reconstruction"]
    },
    {
      id: 5,
      name: "Ben",
      role: "Assistant IA",
      specialization: "Conseil & Information 24/7",
      experience: "Toujours disponible",
      image: "/team/ben.jpg",
      icon: <Bot size={24} />,
      description: "Assistant intelligent pour répondre à vos questions et vous accompagner.",
      certifications: ["IA Conversationnelle", "Support Client"]
    },
  ]

  const teamStats = [
    {
      icon: <TrendingUp size={24} />,
      number: "25+",
      label: "Années d'Expérience Collective"
    },
    {
      icon: <Users size={24} />,
      number: "2000+",
      label: "Patients Accompagnés"
    },
    {
      icon: <Star size={24} />,
      number: "3",
      label: "Experts Spécialisés"
    },
    {
      icon: <Heart size={24} />,
      number: "98%",
      label: "Satisfaction Patient"
    }
  ]

  return (
    <section id="equipe" className="team-section section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Notre Équipe d'Experts</h2>
          <p className="section-subtitle">
            Une équipe pluridisciplinaire dédiée à votre réussite et votre bien-être
          </p>
        </div>

        {/* Team Stats */}
        <div className="team-stats">
          {teamStats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Grid */}
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="member-image">
                <img src={member.image} alt={member.name} />
                <div className="member-badge">
                  {member.icon}
                  <span>{member.role}</span>
                </div>
              </div>

              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <div className="member-role">{member.role}</div>
                <div className="member-specialization">{member.specialization}</div>
                <div className="member-experience">{member.experience}</div>

                <p className="member-description">{member.description}</p>

                <div className="member-certifications">
                  {member.certifications.map((cert, index) => (
                    <span key={index} className="certification-badge">
                      <CheckCircle size={14} />
                      {cert}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Approach */}
        <div className="team-approach">
          <div className="approach-content">
            <h3>Approche Collaborative</h3>
            <p>
              Notre équipe travaille en synergie pour vous offrir une prise en charge complète et personnalisée.
              De la consultation initiale au suivi post-intervention, chaque expert apporte son expertise
              pour garantir votre satisfaction et des résultats optimaux.
            </p>
            <div className="approach-highlights">
              <div className="highlight-item">
                <span className="highlight-number">1</span>
                <span>Consultation pluridisciplinaire</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">2</span>
                <span>Plan de traitement personnalisé</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">3</span>
                <span>Suivi continu et accompagnement</span>
              </div>
            </div>
          </div>
          <div className="approach-image">
            <img src="/assets/real-patients/clinical/clinic-reception.webp" alt="Accueil Clinique du Grand Paris" />
          </div>
        </div>
      </div>

      <style jsx>{`
        .team-section {
          background: linear-gradient(135deg, #E8EAF6 0%, #FFFFFF 100%);
          position: relative;
          overflow: hidden;
        }

        .team-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #2F2F84 0%, #6466B0 50%, #8B6F47 100%);
          z-index: 1;
        }

        .container {
          position: relative;
          z-index: 2;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-title {
          font-size: 3rem;
          font-weight: 700;
          color: #2F2F84;
          margin-bottom: 1rem;
        }

        .section-subtitle {
          font-size: 1.2rem;
          color: #666666;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* Team Stats */
        .team-stats {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 2rem;
          margin-bottom: 4rem;
        }

        .stat-item {
          background: #FFFFFF;
          border: 2px solid #2F2F84;
          border-radius: 16px;
          padding: 2rem;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(47, 47, 132, 0.15);
        }

        .stat-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(47, 47, 132, 0.2);
          border-color: #8B6F47;
        }

        .stat-icon {
          color: #2F2F84;
          margin-bottom: 1rem;
          display: flex;
          justify-content: center;
        }

        .stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: #2F2F84;
          -webkit-text-fill-color: #2F2F84;
          background: none;
          -webkit-background-clip: unset;
          background-clip: unset;
          line-height: 1;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          font-size: 0.9rem;
          color: #333333;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Team Grid */
        .team-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          margin-bottom: 4rem;
        }

        .team-card {
          background: #FFFFFF;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 4px 16px rgba(47, 47, 132, 0.12);
          border: 2px solid #E8EAF6;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .team-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #2F2F84, #8B6F47);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .team-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 32px rgba(47, 47, 132, 0.18);
          border-color: #6466B0;
        }

        .team-card:hover::before {
          transform: scaleX(1);
        }

        .member-image {
          position: relative;
          margin-bottom: 1.5rem;
          overflow: hidden;
          border-radius: 16px;
        }

        .member-image img {
          width: 100%;
          height: 250px;
          object-fit: cover;
          object-position: center top;
          box-shadow: 0 8px 30px rgba(100, 102, 176, 0.3);
          border-radius: 16px;
          transition: transform 0.3s ease;
        }

        .team-card:hover .member-image img {
          transform: scale(1.05);
        }

        .member-badge {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: linear-gradient(45deg, #2F2F84, #8B6F47);
          color: #FFFFFF;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.8rem;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(47, 47, 132, 0.3);
        }

        .member-info {
          text-align: center;
        }

        .member-name {
          font-size: 1.4rem;
          font-weight: 700;
          color: #2F2F84;
          margin-bottom: 0.5rem;
        }

        .member-role {
          font-size: 1rem;
          color: #8B6F47;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .member-specialization {
          font-size: 0.9rem;
          color: #666666;
          margin-bottom: 0.25rem;
        }

        .member-experience {
          font-size: 0.8rem;
          color: #6466B0;
          font-weight: 500;
          margin-bottom: 1rem;
        }

        .member-description {
          font-size: 0.9rem;
          color: #333333;
          line-height: 1.5;
          margin-bottom: 1.5rem;
        }

        .member-certifications {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          justify-content: center;
        }

        .certification-badge {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          background: rgba(100, 102, 176, 0.1);
          border: 1px solid rgba(100, 102, 176, 0.2);
          border-radius: 12px;
          padding: 0.25rem 0.5rem;
          font-size: 0.7rem;
          color: #6466B0;
          font-weight: 500;
        }

        /* Team Approach */
        .team-approach {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
          background: rgba(100, 102, 176, 0.1);
          -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(100, 102, 176, 0.2);
          border-radius: 20px;
          padding: 3rem;
        }

        .approach-content h3 {
          font-size: 2rem;
          font-weight: 700;
          color: #2F2F84;
          margin-bottom: 1.5rem;
        }

        .approach-content p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #333333;
          margin-bottom: 2rem;
        }

        .approach-highlights {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .highlight-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          color: #2F2F84;
          font-weight: 500;
        }

        .highlight-number {
          background: linear-gradient(45deg, #6466B0, #8B6F47);
          color: #2F2F84;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.9rem;
        }

        .approach-image img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 16px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .team-stats {
            grid-template-columns: repeat(2, 1fr);
          }

          .team-approach {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
        }

        @media (max-width: 768px) {
          .section-title {
            font-size: 2rem;
          }
        }
      `}</style>
    </section>
  )
}

export default TeamSection